import Angular from "angular";
import Template from "./week-calendar.html";
import Controller from "./calendar.controller.js";
import CalendarItem from "./calendar-item";

var WeekCalendarModule = Angular.module('week-calendar', [CalendarItem.name])

    .component('weekCalendar', {
        template: Template,
        controller: Controller,
        transclude: {
            'calendarItemContent': '?calendarItemContent'
        },
        bindings: {
            calendar: "<",
            onItemTap: "&",
            zoom: '<',
            minZoom: '<',
            maxZoom: '<'
        }
    });

export default WeekCalendarModule;



// WEBPACK FOOTER //
// ./src/modules/main/components/calendar/week-calendar.js